// Module
var code = `
<miscellaneous-transactions-page header-title="'Close accounting period'" form-title="'Period details'">
  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.form">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
        <tr>
          <td></td>
          <td>Select year to be closed:</td>
          <td>
            <input
              name="year"
              type="text"
              ng-model="\$ctrl.year"
              moment-picker
              max-view="year"
              min-view="decade"
              format="YYYY"
              required
            />
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Period to be closed:</td>
          <td>{{\$ctrl.getPeriod()}}</td>
        </tr>
        <tr>
          <td></td>
          <td>Closing date:</td>
          <td>{{\$ctrl.getClosingDate()}}</td>
        </tr>
        <tr>
          <td></td>
          <td>System date:</td>
          <td>{{\$ctrl.systemDate | prettyDate}}</td>
        </tr>
      </tbody>
    </table>
  </form>

  <div class="check-control-buttons buttons">
    <button
        class="misc-transaction__cancel btn btn-warning"
        ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>
    <button
        type="button"
        class="misc-transaction__save btn btn-primary"
        ng-disabled="\$ctrl.form.\$invalid"
        ng-click="\$ctrl.save()">
      Schedule accounting period closure
    </button>
  </div>
</miscellaneous-transactions-page>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/schedule-accounting-period-closure/schedule-accounting-period-closure.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;